var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.36 12.92C38.32 12.92 34.8 7.64 33.92 5C28.64 9.928 22.6267 7.05333 20.28 5C17.112 12.04 11.04 13.2133 8.4 12.92C9.104 20.312 5.76 25.3867 4 27C8.928 31.576 8.69333 38 7.96 40.64C15 40.64 18.52 46.2133 19.4 49C25.032 44.776 31.4267 47.24 33.92 49C34.976 43.368 42.28 41.08 45.8 40.64C42.984 33.248 47.8533 28.4667 50.64 27C44.656 23.48 44.6267 16.1467 45.36 12.92Z",
    stroke: "#00AFF0",
    strokeWidth: 4.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6809 18.1997L18.9609 34.9197",
    stroke: "#00AFF0",
    strokeWidth: 4.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7854 18.904L20.809 18.9073M32.9756 35.0959L32.9993 35.0992M21.968 19.0707C21.8759 19.7239 21.2718 20.1787 20.6186 20.0866C19.9655 19.9945 19.5107 19.3904 19.6028 18.7373C19.6949 18.0842 20.299 17.6293 20.9521 17.7214C21.6052 17.8135 22.0601 18.4176 21.968 19.0707ZM34.1582 35.2626C34.0661 35.9158 33.462 36.3706 32.8089 36.2785C32.1558 36.1864 31.701 35.5823 31.793 34.9292C31.8851 34.2761 32.4892 33.8212 33.1424 33.9133C33.7955 34.0054 34.2503 34.6095 34.1582 35.2626Z",
    stroke: "#00AFF0",
    strokeWidth: 5.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.53c3200374d57e6123332fb28d07fec5.svg";
export { ForwardRef as ReactComponent };